import { useParams } from 'react-router';
import PolicyApplicationForm from '@/components/policy-application/PolicyApplicationForm';
import { PilotBlockedPage } from '@/shared/components/pilot-blocked-page';
import { useIsPilotRestricted } from '@/shared/hooks/use-active-pilot-program';

export function PolicyApplicationFormPage() {
  const { clientId, clientPolicyApplicationId, formId, forClientId } = useParams();
  const isQuoteApplyRestricted = useIsPilotRestricted('quote-apply');

  if (isQuoteApplyRestricted) {
    return (
      <PilotBlockedPage
        capability="quote-apply"
        clientId={clientId}
      />
    );
  }

  if (!clientId || !clientPolicyApplicationId || !formId) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50">
        <div className="text-center">
          <h2 className="mb-2 text-xl font-semibold text-gray-900">Form not found</h2>
          <p className="text-gray-700">The requested form could not be loaded.</p>
        </div>
      </div>
    );
  }

  return (
    <PolicyApplicationForm
      clientPolicyApplicationId={clientPolicyApplicationId}
      formId={formId}
      clientId={clientId}
      forClientId={forClientId as string}
    />
  );
}
